export const reportError = {
  reportError: {
    reportError: "Report error",
    tellUs: "Tell us...",
    whatHappened: "What happened?",
    feedback: "Feedback",
  },
};
